import { render, staticRenderFns } from "./DiplomesDropDownMenu.vue?vue&type=template&id=31a9cdf9"
import script from "./DiplomesDropDownMenu.vue?vue&type=script&lang=js"
export * from "./DiplomesDropDownMenu.vue?vue&type=script&lang=js"
import style0 from "./DiplomesDropDownMenu.vue?vue&type=style&index=0&id=31a9cdf9&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports